import CampaignsFilters from 'modules/Services/CampaignsEditor/filtersConfigs/campaigns'
import AdGroupsFilters from 'modules/Services/CampaignsEditor/filtersConfigs/ad-groups'
import BannersFilters from 'modules/Services/CampaignsEditor/filtersConfigs/banners'

const FILTERS_MAP = {
  campaigns: CampaignsFilters,
  'ad-groups': AdGroupsFilters,
  banners: BannersFilters,
}

export default (resource) => FILTERS_MAP?.[resource] ?? { initial: {} }
